import React, { Component } from "react";
import ExpenseIcon from "./ExpenseIcon";

export default class ExpenseDetail extends Component {
  formatDate(date) {
    const dateParts = date.split("/");
	if (dateParts[1].length < 2) 
        dateParts[1] = '0' + dateParts[1];
	 if (dateParts[0].length < 2) 
        dateParts[0] = '0' + dateParts[0];
    return `${dateParts[0]}.${dateParts[1]}.20${dateParts[2]}`;
  }

  render() {
    return (
      <li
        className="mdc-list-item"
        onClick={() => this.props.onSelect(this.props.expense)}
      >
        <ExpenseIcon category={this.props.expense.category} />
        <span className="mdc-list-item__text">
          {this.props.expense.category}
          <span className="mdc-list-item__text__secondary">
            {this.formatDate(this.props.expense.date)}
            {this.props.expense.description
              ? ` ${this.props.expense.description.replace(/^(.{14}).+/, "$1…")}`
              : ""}
          </span>
        </span>
        <span className="mdc-list-item__end-detail">
          {this.props.expense.amount.toFixed(2)}€
        </span>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/expense-list/ExpenseDetail.js